import { isEmpty, map } from 'lodash'

const transformMenuTitlesToTableView = menuTitles =>
  map(menuTitles, menuTitle => ({
    ...menuTitle,
    children: isEmpty(menuTitle.children)
      ? null
      : transformMenuTitlesToTableView(menuTitle.children),
  }))

export default transformMenuTitlesToTableView
